export const shouldRefreshAfterActionError = (error) => {
  const status = Number(error?.status ?? error?.response?.status);
  return status === 409 || status === 422;
};
